<template>
  <div class="home-content-page-v ajust-order">
    <div class="href-content t-content">
      <div class="left-content search-form">
        <content-title :title="todayStr" :actions="actions_search" @clickMenu="clickMenuS"></content-title>
        <div class="form-content">
          <el-select v-model="oilType" placeholder="油品">
            <el-option v-for="item in ['汽油', '柴油']" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-select v-model="team" placeholder="油库">
            <el-option v-for="item in carTeams" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <!-- <el-checkbox-group v-model="orderStatus" style="margin: 0 1rem;display: flex !important;">
            <el-checkbox label="紧急订单">紧急</el-checkbox>
            <el-checkbox label="可配送订单">可配送</el-checkbox>
            <el-checkbox label="库存充足订单">库存充足</el-checkbox>
          </el-checkbox-group> -->
          <a class="adjust-btn" style="background-color:#0b5591;color: #fff;" href="javascript:;" @click="addYaohuoToplan">要货定单加入计划中</a>
          <el-checkbox-group v-model="boardings" style="margin: 0 1rem;display: flex !important;">
            <el-checkbox label="no_delivery">未上车</el-checkbox>
            <el-checkbox label="delivery">已上车</el-checkbox>
          </el-checkbox-group>
          <div>
            <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">要货</span>
             <el-switch v-model="yaoHuoBJ" :active-text="'显示要货'" :inactive-text="'不显示要货'"></el-switch>
          </div>
          <div>
            <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">全部车辆</span>
             <el-switch v-model="allCar" :active-text="'全部车辆'" :inactive-text="'车队筛选'"></el-switch>
          </div>
        </div>
      </div>
      <div class="right-content-1" style="margin-right: 0.7rem;">
        <content-title :title="'计划：' + chooseOrderCg.length" :actions="actions3" @clickMenu="clickMenu"></content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table :datas="chooseOrderCg" :table_style="1" :ths="jhOrderListThs" @click_row="clickOrderRow" :table_actions="tableActionOrder3" @clickTdBtn="clickOrderTdBtnSD" :lineQF="true"></mii-base-table>
          <content-title :title="'锁定：' + chooseOrders.length" :actions="actions" @clickMenu="clickMenu"></content-title>
          <mii-base-table :datas="chooseOrders" :table_style="1" :ths="jhOrderListThs" @click_row="clickOrderRow" :table_actions="tableActionOrder2" @clickTdBtn="clickOrderTdBtn" :lineQF="true"></mii-base-table>
        </div>
      </div>
      <div class="right-content-1-2" v-loading="orderLoading">
        <content-title :title="'订单：' + showOrderList.length" :actions="actions2" @clickMenu="clickMenu" :searchInput="true" @searchInputChange="searchInputChange1" :clearNum="clearNum">
        </content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table :datas="showOrderList" :table_style="2" :ths="allOrderListThs" @click_row="chooseThisOrder" :table_actions="tableActionOrder" @clickTdBtn="clickOrderTdBtn" @click_row_data="clickRowData" :lineQF="true" :show_dian="true" :lineSuo="'SFID'" :chooseRowValue="chooseOrderValue" :chooseAction="{action: 'clickTdBtn', key: 'oil_detail'}"></mii-base-table>
        </div>
      </div>
    </div>
    <div class="href-content" style="margin-bottom: 1rem;">
      <div class="left-content" v-loading="carLoading">
        <content-title :title="'车辆：' + carList.length" :searchInput="true" @searchInputChange="searchInputChange2" :clearNum="clearNum + clearNumZd"></content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table :datas="showCarList" :table_style="2" :ths="carListThs" @click_row="clickCarRow" :table_actions="tableActionCar" @clickTdBtn="clickOrderTdBtn" :lineSuo="'车牌号'" :chooseRowValue="chooseCarValue" :chooseAction="{action: 'click_row'}"></mii-base-table>
        </div>
      </div>
      <div class="right-content-2 static-content" v-loading="carOrderLoading" v-if="showCarOrderType === 'car'">
        <div class="static-content-div" v-if="chooseCar && !chooseCar.dc">
          <div class="one-input select-order" v-if="chooseCar['前仓']">
          <el-select style="flex: 1" size="mini" v-model="chooseOrder1" filterable :placeholder="'前仓：' + chooseCar['前仓']">
            <el-option style="max-width: 30rem;" v-for="(item, index) in canChooseOrders" :key="item.SFID + String(index)" :label="item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART" :value="item.SFID">
            </el-option>
          </el-select>
        </div>
        <div class="one-input select-order" v-if="chooseCar['中仓']">
          <el-select style="flex: 1" size="mini" v-model="chooseOrder2" filterable :placeholder="'中仓：' + chooseCar['中仓']">
            <el-option style="max-width: 30rem;" v-for="(item, index) in canChooseOrders" :key="item.SFID + String(index) + '_1'" :label="item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART" :value="item.SFID">
            </el-option>
          </el-select>
        </div>
        <div class="one-input select-order" v-if="chooseCar['后仓']">
          <el-select style="flex: 1" size="mini" v-model="chooseOrder3" filterable :placeholder="'后仓：' + chooseCar['后仓']">
            <el-option style="max-width: 30rem;" v-for="(item, index) in canChooseOrders" :key="item.SFID + String(index) + '_2'" :label="item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART" :value="item.SFID">
            </el-option>
          </el-select>
        </div>
        <a class="adjust-btn" href="javascript:;" @click="saveCarOrderDuo">保存</a>
        </div>
        <content-title :title="(chooseCar ? chooseCar['车牌号'] : '')  + (chooseOrder ? ' >> ' + chooseOrder['油站名'] : '')" :actions="actions4" @clickMenu="clickMenu"></content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table :datas="showCarOrderList" :table_style="1" :table_actions="tableAction" @clickTdBtn="clickTdBtn" :ths="carOrderListThs" :realAction="true"></mii-base-table>
        </div>
      </div>
      <div class="right-content-2 static-content" v-loading="carOrderLoading" v-if="showCarOrderType === 'oil'">
        <content-title :title="carOrderTitle" :actions="actions4" @clickMenu="clickMenu"></content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table @click_row_data="clickRowDataCarOrder" :datas="showOilCarOrderList" :table_style="1" :table_actions="tableActionOil" @clickTdBtn="clickTdBtn" :ths="carOrderListThsOil" :realAction="true"></mii-base-table>
        </div>
      </div>
      <div class="right-content-2 static-content" v-loading="carOrderLoading" v-if="showCarOrderType === 'jxc'">
        <content-title :title="jxcTitle + ' >> 进销存'"></content-title>
        <div style="overflow: auto;flex: 1;">
          <mii-base-table :datas="jxcDatas" :table_style="1" :ths="jxcThs"></mii-base-table>
        </div>
      </div>
    </div>
    <el-dialog :title="chooseOrderChangeDepot['加油站名称'] + ' >>> 订单油库变更'" :visible.sync="showChooseDepot" size="tiny">
      <div class="case-form">
        <span>选择油库</span>
        <el-select size="small" v-model="chooseOrderChangeDepot['油库代码']" filterable placeholder="请输入关键词">
          <el-option v-for="item in depotList" :key="item['油库代码']" :label="item['油库名称']" :value="item['油库代码']">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChooseDepot = false">取 消</el-button>
        <el-button type="primary" @click="saveChangeOrderDepot">保存修改</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="chooseCarOrder ? (chooseCarOrder['加油站名称'] + ' >>> 配送单油库变更') : ''" :visible.sync="showChooseDepotPs" size="tiny">
      <div style="margin-bottom: 1rem;">
        <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">整车调整</span>
        <el-radio-group v-model="allCarOrder">
          <el-radio :label="'only'">该运单</el-radio>
          <el-radio :label="'tang'">本趟次</el-radio>
          <el-radio :label="'dayCar'">全车</el-radio>
        </el-radio-group>
      </div>
      <div class="case-form" v-if="chooseCarOrder">
        <span>选择油库</span>
        <el-select size="small" v-model="psDepot" filterable placeholder="请输入关键词">
          <el-option v-for="item in depotList" :key="item['油库代码']" :label="item['油库名称']" :value="item['油库代码']">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChooseDepotPs = false">取 消</el-button>
        <el-button type="primary" @click="saveChangePsDepot">保存修改</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="chooseCar ? chooseCar['车牌号'] : ''" :visible.sync="showCarDetail">
      <div style="display:flex;" v-if="chooseCar">
        <div class="one-input" style="display: flex;margin-top: 1rem;align-items: center;flex: 1;" v-if="chooseCar['前仓']">
          <span>{{'前仓-' + this.chooseCar['前仓']}}</span>
        </div>
        <div class="one-input" style="display: flex;margin-top: 1rem;align-items: center;flex: 1;" v-if="chooseCar['中仓']">
          <span>{{'中仓-' + this.chooseCar['中仓']}}</span>
        </div>
        <div class="one-input" style="display: flex;margin-top: 1rem;align-items: center;flex: 1;" v-if="chooseCar['后仓']">
          <span>{{'后仓-' + this.chooseCar['后仓']}}</span>
        </div>
        <div class="one-input" style="display: flex;margin-top: 1rem;align-items: center;flex: 1;" v-for="(item, key) in carDetail['xzData']" v-if="item && key !== '车牌号'">
          <span>{{key + '-' + item}}</span>
        </div>
      </div>
      <div v-if="carDetail['psData'].length > 0" style="margin-top: 1rem;">
        <content-title title="近三天配送记录"></content-title>
        <mii-base-table :datas="carDetail['psData']" :table_style="2" :ths="psjlThs" :lineQF="true"></mii-base-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCarDetail= false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="chooseOrderChangeDepot['加油站名称'] + ' >>> 订单拆分'" :visible.sync="showSplitOrder" size="tiny">
      <div class="case-form">
        <span>拆单数</span>
        <el-select size="small" v-model="splitNum" filterable placeholder="选择拆单数">
          <el-option v-for="item in [2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div style="display:flex;flex-wrap:wrap;">
        <div class="one-input" v-for="(item, index) in splitOrderData" v-if="item && !(Number(index) > splitNum)" style="display: flex;margin-top: 1rem;align-items: center;width: 50%;">
          <span style="width: 3rem">{{'新单' + index}}</span>
          <el-input style="width: 7rem" v-model="splitOrderData[index]" size="small" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSplitOrder = false">取 消</el-button>
        <el-button type="primary" @click="saveSplitOrder">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="chooseCarOrder && chooseCarOrder ? chooseCarOrder['车牌号'] + '  >>> ' + chooseCarOrder['加油站名称'] + ' >>> 趟次调整' : ''" :visible.sync="showTctz" size="tiny">
      <div class="case-form">
        <span>趟次调整</span>
        <el-select size="small" v-model="tc" filterable placeholder="选择趟次">
          <el-option v-for="item in tcList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showTctz = false">取 消</el-button>
        <el-button type="primary" @click="saveTctz">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="系统提示" :visible.sync="showAddTs" size="tiny">
      <div class="case-form">
        <span>配送单还未保存，是否确认切换</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addTsAction('back')">返回</el-button>
        <el-button @click="addTsAction('change')">切换</el-button>
        <el-button type="primary" @click="addTsAction('sc')">保存并切换</el-button>
      </div>
    </el-dialog>
    <el-dialog title="运单导出" :visible.sync="showOutput">
      <div class="case-form">
        <el-checkbox-group v-model="outPutOilType" style="margin: 0 1rem 1rem;display: flex !important;">
          <el-checkbox label="汽油">汽油</el-checkbox>
          <el-checkbox label="柴油">柴油</el-checkbox>
        </el-checkbox-group>
        <template>
        <content-title :title="'总单数:' + orderCar.length"></content-title>
        <mii-table-oil :datas="orderTj" :columns="orderTjThs" :mergeRowKeyList="['油库名称', '油品名称', 'DEPOT_TOTAL', 'DEPOT_TOTAL_L']"></mii-table-oil>  
        </template>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showOutput = false">返回</el-button>
        <el-button type="primary" @click="outputPsDatas" v-if="orderCar.length > 0">导出</el-button>
      </div>
    </el-dialog>
    <el-dialog title="要货概览" :visible.sync="showYaohuo">
      <div class="case-form">
        <div style="display: flex;">
          <el-checkbox-group v-model="yaoHuoOilType" style="margin: 0 1rem 1rem;display: flex !important;">
            <el-checkbox label="汽油">汽油</el-checkbox>
            <el-checkbox label="柴油">柴油</el-checkbox>
          </el-checkbox-group>
          <el-input style="width: 7rem;" v-model="yaoHuoMin" size="mini" placeholder="最小要货差值"></el-input>
        </div>
        <template>
        <content-title :title="'要货量'" @searchInputChange="searchInputChange3" :searchInput="true" :clearNum="clearNum"></content-title>
        <mii-table-oil :datas="showYaoHuoCheckList" :columns="yaohuoThs" :mergeRowKeyList="['加油站名称', '油品名称', '要货量', 'TOTAL_PS', '差值']"></mii-table-oil>  
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showYaohuo = false">返回</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="oilDetailMap['加油站名称']" :visible.sync="showOilDetail" size="large">
      <oil-ps-detail></oil-ps-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showOilDetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="selectArea" :visible.sync="showAreaJxc" size="large">
      <area-jxc></area-jxc>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAreaJxc = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增运送订单" :visible.sync="showAdd" size="small">
      <div class="case-form case-form-gas">
        <el-select v-model="chooseGIndex" filterable placeholder="请输入关键词">
          <el-option style="max-width: 27rem;" v-for="(item, index) in gasDatas" :key="item['代号'] + index" :label="item['加油站名称'] + '-' + item['罐号'] + '罐' + '-' + item['油品名称'] + '--------------------------' + item['DXCHART']" :value="index">
          </el-option>
        </el-select>
      </div>
      <div class="case-form case-form-gas" v-if="chooseG && chooseG.油站代码">
        <div class="one-input">
          <span>加油站</span>
          <el-input v-model="chooseG.加油站名称" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>罐号</span>
          <el-input v-model="chooseG.罐号" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>油品</span>
          <el-input v-model="chooseG.油品名称" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>期初库存</span>
          <el-input v-model="newOrder.期初库存" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>入库升数</span>
          <el-input v-model="newOrder.入库升数" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>出库升数</span>
          <el-input v-model="inputCKSS" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>期末库存</span>
          <el-input v-model="newOrder.期末库存" :disabled="true" size="small" placeholder=""></el-input>
        </div>
        <div class="one-input">
          <span>空容</span>
          <el-input v-model="newOrder.空容" :disabled="true" size="small" placeholder=""></el-input>
        </div>
        <div class="one-input">
          <span>断货时间</span>
          <el-input v-model="newOrder.断货时间" :disabled="true" size="small" placeholder=""></el-input>
        </div>
        <div class="one-input">
          <span>订单紧急程度</span>
          <el-select v-model="newOrder['订单紧急程度']" placeholder="请选择" size="small">
            <el-option v-for="item in ['可配送订单', '紧急订单', '库存充足订单']" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>小罐多销</span>
          <el-select v-model="newOrder['小罐多销']" placeholder="请选择" size="small">
            <el-option v-for="item in [{label: '是', key: 1}, {label: '不是', key: 0}]" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>配送油库</span>
          <el-select size="small" v-model="newOrder['油库代码']" filterable placeholder="请输入关键词">
            <el-option v-for="item in depotList" :key="item['油库代码']" :label="item['油库名称']" :value="item['油库代码']">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>建议配送量</span>
          <el-input v-model="inputPSL" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>不容纳时间</span>
          <el-input v-model="newOrder['不容纳时间']" :disabled="true" size="small" placeholder=""></el-input>
        </div>
        <div class="one-input">
          <span>当日加单</span>
          <el-select v-model="newOrder['当日加单']" placeholder="请选择" size="small">
            <el-option v-for="item in [{label: '是', key: 1}, {label: '不是', key: 0}]" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="saveGasOrder">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
import OilPsDetail from './oil_ps_detail'
import AreaJxc from './area_jxc'
import MiiTableOil from '@/components_bit/MiiTableOil'

import {
  car,
  gas,
  depotValume
} from '@/api/oli_api'

import {
  concatList,
  mapCp,
  dateOperating
} from '@/cllib'

let nullOrder = {
  '油站代码': '',
  '代号': '',
  '时间': '',
  '平均销量': '',
  '期初库存': 0,
  '入库升数': '',
  '出库升数': 10000,
  '期末库存': '',
  '空容': '',
  '断货时间': '',
  '订单紧急程度': '库存充足订单',
  '小罐多销': 0,
  '油库代码': '',
  '建议配送量': 10000,
  '不容纳时间': '',
  '当日加单': 0
}

let jhOrderThs = [{
  label: 'ID',
  key: 'SFID'
},
{
  label: '加油站',
  key: '油站名',
  shortType: 'text'
},
{
  label: '罐',
  key: '罐号'
},
{
  label: '油品',
  key: '油品名',
  shortType: 'text'
},
{
  label: '预配送',
  key: '建议配送量'
}]

let orderAdjustStatus = {
  'normal': '未',
  'locking': '定',
  'plan': '待',
  'done': '已'
}

let allOrderThs = [{
  label: '',
  key: 'STATUS',
  shortType: 'text',
  showText: (data) => {
    return orderAdjustStatus[data]
  }
},
{
  label: '加油站',
  key: '油站名',
  shortType: 'text',
  clickAction: 'choose_station'
},
{
  label: '罐',
  key: '罐号',
  clickAction: 'choose_station_guan'
},
{
  label: '油品',
  key: '油品名',
  shortType: 'text',
  clickAction: 'choose_station_oiltype'
},
{
  label: '不容纳',
  key: '不容纳时间',
  shortType: 'time'
},
{
  label: '断货',
  key: '断货时间',
  shortType: 'time'
},
{
  label: '预配送',
  key: '建议配送量',
  clickAction: 'choose_jyps'
},
{
  label: '运距',
  key: '运距'
},
{
  label: '油库',
  key: '油库',
  shortType: 'text'
}]

let carTeamDl = ['丽江车队', '迪庆车队', '德宏车队', '大理车队', '临沧车队', '保山车队', '景东车队', '怒江车队']
let carTeamKm = ['昆东', '长坡']
let carTeamHh = ['红河车队', '文山车队']
let carTeamYp = ['玉溪车队', '景洪车队', '普洱西盟江城澜沧孟连车队']
let carTeamZp = ['松林油库', '水富油库', '北闸油库']

export default {
  components: {
    ContentTitle,
    MiiBaseTable,
    OilPsDetail,
    AreaJxc,
    MiiTableOil
  },
  data () {
    return {
      yaoHuoMin: '',
      outPutOilType: ['汽油', '柴油'],
      yaoHuoOilType: ['汽油', '柴油'],
      showOilCarOrderList: [],
      carOrderTitle: '',
      jxcTitle: '',
      carOrderOilData: '',
      showCarOrderType: 'car',
      searchYaohuo: '',
      yaoHuoCheckList: [],
      showYaohuo: false,
      yaoHuoBJ: false,
      allCarOrder: 'tang',
      leftRightQH: null,
      num: 0,
      chooseCarValue: -1,
      chooseOrderValue: -1,
      boardings: ['no_delivery'],
      allCar: false,
      selectArea: '',
      chooseOrder1: -1,
      chooseOrder2: -1,
      chooseOrder3: -1,
      chooseGIndex: -1,
      showOilDetail: false,
      oilDetailMap: {},
      clearNum: 0,
      clearNumZd: 0,
      tc: '',
      chooseOrderBXHis: null,
      chooseOrderBX: null,
      showAddTs: false,
      showAreaJxc: false,
      chooseOrderHis: [],
      tcList: [],
      wfpKey: '',
      carKey: '',
      team: '',
      splitNum: 2,
      inputCKSS: 0,
      inputPSL: 0,
      actions: [{
        icon: 'icon-clear',
        key: 'clear'
      }],
      actions3: [{
        icon: 'icon-clear',
        key: 'clear3'
      }],
      actions_search: [{
        icon: 'icon-cheliangtiaodu',
        key: 'sys_pipei'
      }],
      actions2: [{
        icon: 'icon-addfriend',
        key: 'add'
      }],
      actions4: [{
        icon: 'icon-woyaorongzi00',
        key: 'yaohuo_check'
      },
      {
        icon: 'icon-daochu',
        key: 'out_put'
      }],
      newOrder: mapCp(nullOrder),
      gasDatas: [],
      showSplitOrder: false,
      showAdd: false,
      showTctz: false,
      showCarDetail: false,
      carDetail: {
        psData: [],
        xzData: {}
      },
      depotList: [],
      carTeams: [],
      oilType: '汽油',
      orderStatus: ['紧急订单', '可配送订单', '库存充足订单'],
      carList: [],
      orderList: [],
      carOrderList: [],
      yunJuMap: {},
      showOutput: false,
      showChooseDepot: false,
      showChooseDepotPs: false,
      carLoading: false,
      orderLoading: false,
      carOrderLoading: false,
      chooseCar: null,
      chooseOrder: null,
      chooseOrders: [],
      psDepot: '',
      chooseOrderChangeDepot: {},
      chooseOrderCg: [],
      chooseCarOrder: null,
      orderTjThs: [{
        label: '油库',
        key: '油库名称'
      },
      {
        label: '油品',
        key: '油品名称'
      },
      {
        label: '总重量(吨)',
        key: 'DEPOT_TOTAL'
      },
      {
        label: '总升数(L)',
        key: 'DEPOT_TOTAL_L'
      },
      {
        label: '配送中心',
        key: '配送中心'
      },
      {
        label: '总重量(吨)',
        key: 'DEPOT_PSZX_TOTAL'
      },
      {
        label: '总升数(L)',
        key: 'DEPOT_PSZX_TOTAL_L'
      }],
      yaohuoThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '油品',
        key: '油品名称'
      },
      {
        label: '要货量',
        key: '要货量'
      },
      {
        label: '合计上车量',
        key: 'TOTAL_PS'
      },
      {
        label: '差值',
        key: '差值'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '上车量',
        key: '配送升数'
      }],
      psjlThs: [{
        label: '时间',
        key: '时间'
      },
      {
        label: '配送加油站',
        key: '加油站名称'
      },
      {
        label: '配送升数(L)',
        key: '配送升数'
      }],
      carListThs: [{
        label: '车牌号',
        key: '车牌号',
        shortType: 'text'
      },
      {
        label: '容积和',
        key: '合计'
      },
      {
        label: '在途',
        key: '在途时间'
      },
      {
        label: '承运商',
        key: '承运商',
        shortType: 'text'
      },
      {
        label: '运距和',
        key: 'sumYJ'
      },
      {
        label: '最后配送',
        key: 'oldPs',
        shortType: 'text'
      }],
      jxcThs: [{
        label: '加油站',
        key: '油站名'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '油品',
        key: '油品名'
      },
      {
        label: '入库',
        key: '入库升数'
      },
      {
        label: '出库',
        key: '出库升数'
      },
      {
        label: '期末',
        key: '期末库存'
      },
      {
        label: '空容',
        key: '空容'
      },
      {
        label: '销量',
        key: '平均销量'
      },
      {
        label: '在途',
        key: '在途计划升数'
      },
      {
        label: '预配送',
        key: '配送计划'
      },
      {
        label: '物理容积',
        key: '物理容积'
      },
      {
        label: '停泵库存',
        key: '停泵库存'
      },
      {
        label: '有效容积',
        key: '有效容积'
      }],
      tableActionOrder: [{
        label: '详',
        key: 'oil_detail'
      },
      {
        label: '库',
        key: 'change_depot',
        hideByData: (data) => {
          return data['STATUS'] === 'normal'
        }
      },
      {
        label: '拆',
        key: 'split_order',
        hideByData: (data) => {
          return data['STATUS'] === 'normal'
        }
      }],
      tableActionCar: [{
        label: '详',
        key: 'detail'
      }],
      tableActionOrder2: [{
        label: '销',
        key: 'area_jxc'
      },
      {
        label: '清',
        key: 'back'
      }],
      tableActionOrder3: [{
        label: '销',
        key: 'area_jxc'
      },
      {
        label: '清',
        key: 'back'
      },
      {
        label: '定',
        key: 'clock'
      }],
      tableAction: [{
        label: '保存',
        key: 'save',
        hideByData: (data) => {
          return data['isNew']
        }
      },
      {
        label: '详',
        key: 'oil_detail'
      },
      {
        label: '调',
        key: 'tiao',
        hideByData: (data) => {
          return !data['isNew']
        }
      },
      {
        label: '库',
        key: 'psk',
        hideByData: (data) => {
          return !data['isNew']
        }
      },
      {
        label: '删',
        key: 'del',
        hideByData: (data) => {
          return !data['isNew']
        }
      }],
      tableActionOil: [{
        label: '详',
        key: 'oil_detail'
      },
      {
        label: '库',
        key: 'psk',
        hideByData: (data) => {
          return !data['isNew']
        }
      },
      {
        label: '删',
        key: 'del',
        hideByData: (data) => {
          return !data['isNew']
        }
      }],
      carOrderListThs: [{
        label: 'ID',
        key: 'SFID'
      },
      {
        label: '加油站',
        key: '油站名'
      },
      {
        label: '罐',
        key: '罐号'
      },
      {
        label: '油品',
        key: '油品名'
      },
      {
        label: '配送量',
        key: '配送升数'
      },
      {
        label: '不容纳',
        key: '不容纳时间'
      },
      {
        label: '发车',
        key: '预计发车时间'
      },
      {
        label: '断货',
        key: '断货时间'
      },
      {
        label: '在途',
        key: '在途时间'
      },
      {
        label: '趟次',
        key: '趟次'
      },
      {
        label: '油库',
        key: '油库'
      }],
      carOrderListThsOil: [{
        label: '车牌号',
        key: '车牌号',
        clickAction: 'choose_car'
      },
      {
        label: '加油站',
        key: '油站名'
      },
      {
        label: '罐',
        key: '罐号'
      },
      {
        label: '油品',
        key: '油品名'
      },
      {
        label: '配送量',
        key: '配送升数'
      },
      {
        label: '不容纳',
        key: '不容纳时间'
      },
      {
        label: '发车',
        key: '预计发车时间'
      },
      {
        label: '断货',
        key: '断货时间'
      },
      {
        label: '在途',
        key: '在途时间'
      },
      {
        label: '趟次',
        key: '趟次'
      },
      {
        label: '油库',
        key: '油库'
      }]
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.flowStatus < 30) {
      next({name: 'single.single'})
    } else if (store.getters.flowStatus === 30) {
      store.dispatch('assignCarOrder', false)
      next()
    } else {
      next()
    }
  },
  created () {
    this.initOnKeydown()
    let datas = []
    if (this.oilArea === 'dl') {
      datas = carTeamDl
    } else if (this.oilArea === 'hh') {
      datas = carTeamHh
    } else if (this.oilArea === 'km') {
      datas = carTeamKm
    } else if (this.oilArea === 'zt') {
      datas = carTeamZp
    } else if (this.oilArea === 'yx') {
      datas = carTeamYp
    }
    this.carTeams = datas
    this.team = this.carTeams[0]
    this.loadData()
    this.loadOrderList(['plan', 'normal'])
  },
  watch: {
    allCar () {
      this.loadCarList()
    },
    inputPSL (value) {
      this.dealInputPSL(value)
    },
    inputCKSS (value) {
      this.dealInputCKSS(value)
    },
    oilType (value, oldValue) {
      this.clearNum += 1
      this.loadCarList()
      this.loadOrderList(['plan', 'normal'])
    },
    team (value, oldValue) {
      this.clearNum += 1
      if (oldValue) {
        this.loadOrderList(['plan', 'normal'])
      }
      if (!this.allCar) {
        this.loadCarList()
      }
    },
    chooseCar (value, oldValue) {
      this.carOrderList = []
      if (value && (!oldValue || (value !== oldValue))) {
        this.loadCarOrderList()
      }
      this.chooseOrder1 = null
      this.chooseOrder2 = null
      this.chooseOrder3 = null
    },
    orderStatus () {
      this.loadOrderList(['normal'])
    },
    chooseG (value) {
      if (!value) {
        return
      }
      this.inputPSL = 10000
      this.inputCKSS = 10000
      this.newOrder = mapCp(nullOrder)
      if (value['油站代码']) {
        this.newOrder['油站代码'] = value['油站代码']
        this.newOrder['油库代码'] = this.depotList[0]['油库代码']
        this.newOrder['代号'] = value['代号']
        this.newOrder['时间'] = this.todayStr
        this.newOrder['入库升数'] = value['配送升数'] || 0
        this.newOrder['期初库存'] = value['期末库存'] || 0
      }
      this.dealInputCKSS(this.inputCKSS, true)
      this.dealInputPSL(this.inputPSL)
    }
  },
  computed: {
    jxcDatas: {
      get () {
        let data = this.$store.getters.oilHisJxcDatas
        data.forEach((item) => {
          item = this.delOrderData(item)
        })
        return data
      }
    },
    jhOrderListThs: {
      get () {
        let data = []
        jhOrderThs.forEach((item, index) => {
          data.push(item)
          if (item['key'] === '建议配送量' && this.yaoHuoBJ) {
            data.push({key: '要货量', label: '要货量'})
          }
        })
        return data
      }
    },
    allOrderListThs: {
      get () {
        let data = []
        allOrderThs.forEach((item) => {
          data.push(item)
          if (item['key'] === '建议配送量' && this.boardings.includes('delivery')) {
            data.push({
              key: 'PS_TOTAL',
              label: '上车量',
              clickAction: 'choose_station_ps'
            })
          }
          if (item['key'] === '建议配送量' && this.yaoHuoBJ) {
            data.push({key: '要货量', label: '要货量'})
          }
        })
        return data
      }
    },
    chooseG: {
      get () {
        if (this.chooseGIndex === 0 || (this.chooseGIndex && this.chooseGIndex > -1)) {
          return this.gasDatas[this.chooseGIndex]
        } else {
          return {}
        }
      }
    },
    chooseAdjustOrders: {
      get () {
        let cd1 = null
        let cd2 = null
        let cd3 = null
        this.canChooseOrders.forEach((item) => {
          if (item['SFID'] === this.chooseOrder1) {
            cd1 = item
          }
          if (item['SFID'] === this.chooseOrder2) {
            cd2 = item
          }
          if (item['SFID'] === this.chooseOrder3) {
            cd3 = item
          }
        })
        let data = {
          qc: cd1,
          zc: cd2,
          hc: cd3
        }
        return data
      }
    },
    orderCar: {
      get () {
        let data = []
        this.$store.getters.orderCar.forEach((item) => {
          let need = false
          this.outPutOilType.forEach((itemOilType) => {
            if (item['油品名称'].includes(itemOilType)) {
              need = true
            }
          })
          if (need) {
            data.push(item)
          }
        })
        return data
      }
    },
    canChooseOrders: {
      get () {
        let data = []
        this.chooseOrderCg.forEach((item) => {
          data.push(item)
        })
        this.chooseOrders.forEach((item) => {
          data.push(item)
        })
        return data
      }
    },
    showCarList: {
      get () {
        let data = []
        this.carList.forEach((item) => {
          if (item['车牌号'].indexOf(this.carKey) > -1 || item['承运商'].indexOf(this.carKey) > -1) {
            data.push(item)
          }
        })
        return data
      }
    },
    showOrderList: {
      get () {
        let data1 = []
        this.orderList.forEach((item) => {
          if (this.boardings.includes('delivery') && item['STATUS'] === 'done') {
            data1.push(item)
          }
          if (this.boardings.includes('no_delivery') && item['STATUS'] !== 'done') {
            data1.push(item)
          }
        })
        let data = []
        data1.forEach((item) => {
          let DXCHART = item['DXCHART'] || ''
          if (DXCHART.includes(this.wfpKey) || String(item['SFID']).includes(this.wfpKey) || item['油库代码'].includes(this.wfpKey) || item['加油站名称'].includes(this.wfpKey)) {
            data.push(item)
          }
        })
        return data
      }
    },
    todayStr: {
      get () {
        return this.$store.getters.todayStr
      }
    },
    orderTj: {
      get () {
        let data = []
        this.$store.getters.orderTj.forEach((item) => {
          let need = false
          this.outPutOilType.forEach((itemOilType) => {
            if (item['油品名称'].includes(itemOilType)) {
              need = true
            }
          })
          if (need) {
            data.push(item)
          }
        })
        return data
      }
    },
    oilArea: {
      get () {
        return this.$store.getters.oilArea
      }
    },
    splitOrderData: {
      get () {
        let amount = parseInt((this.chooseOrderChangeDepot['建议配送量'] || 0) / this.splitNum)
        let datas = {'1': amount, '2': amount, '3': amount, '4': amount, '5': amount, '6': amount, '7': amount, '8': amount, '9': amount, '10': amount}
        return datas
      }
    },
    newCarOrder: {
      get () {
        let newData = null
        if (this.chooseOrder && this.chooseCar) {
          newData = {
            '车牌号': this.chooseCar['车牌号'],
            '油库名称': this.chooseOrder['油库名称'],
            '加油站名称': this.chooseOrder['加油站名称'],
            '配送升数': this.chooseCar['合计'],
            '油品名称': this.chooseOrder['油品名称'],
            '不容纳时间': this.getBRNTime(this.chooseOrder, this.chooseCar['合计']),
            '预计发车时间': '',
            '在途时间': this.getOnlineTime(this.chooseOrder['油库代码'], this.chooseOrder['油站代码']),
            '断货时间': this.chooseOrder['断货时间'],
            '油站代码': this.chooseOrder['油站代码'],
            'SFID': this.chooseOrder['SFID'],
            '罐号': this.chooseOrder['罐号'],
            'isNew': true
          }
          this.delCarOrderData(newData)
        }
        return newData
      }
    },
    showCarOrderList: {
      get () {
        return concatList(this.carOrderList, this.newCarOrder ? [this.newCarOrder] : [])
      }
    },
    showYaoHuoCheckList: {
      get () {
        let data = []
        let searchKey = this.searchYaohuo
        this.yaoHuoCheckList.forEach((item) => {
          let DXCHART = item['DXCHART'] || ''
          if (DXCHART.includes(searchKey) || item['加油站名称'].includes(searchKey)) {
            data.push(item)
          }
        })
        let newData = []
        data.forEach((item) => {
          let need = false
          this.yaoHuoOilType.forEach((itemOilType) => {
            if (item['油品名称'].includes(itemOilType)) {
              need = true
            }
          })
          if (need) {
            newData.push(item)
          }
        })
        let yaoHuoMin = Number(this.yaoHuoMin) || 0
        if (yaoHuoMin !== 0) {
          let newData2 = []
          newData.forEach((item) => {
            let cz = item['差值'] || 0
            if (cz * cz > yaoHuoMin * yaoHuoMin) {
              newData2.push(item)
            }
          })
          newData = newData2
        }
        return newData
      }
    }
  },
  methods: {
    clickRowDataCarOrder (data) {
      if (data.action === 'choose_car') {
        this.clearNumZd += 1
        let carData = null
        this.carList.forEach((item) => {
          if (item['车牌号'] === data.value) {
            carData = item
          }
        })
        if (carData) {
          this.chooseCarValue = this.clearNumZd + 'car_id-' + carData['车牌号']
          this.showCarOrderType = 'car'
        } else {
          if (this.allCar) {
            this.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '系统提示',
              message: '该车未找到，请联系管理员'
            })
          } else {
            this.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '该车未找到，请打开全部车辆后点击车牌号'
            })
          }
        }
      }
    },
    clickRowData (data) {
      let rowdata = data.rowdata
      if (data.action === 'choose_jyps') {
        this.$store.dispatch('setOpdOilCode', rowdata['油站代码'])
        this.jxcTitle = rowdata['油站名']
        this.showCarOrderType = 'jxc'
        return
      }
      let carOrderTitle = rowdata['油站名']
      let carOrderOilData = {
        '油站代码': rowdata['油站代码']
      }
      if (data.action !== 'choose_station') {
        carOrderTitle += ' >> ' + data.value
      }
      if (data.action === 'choose_station_guan') {
        carOrderOilData['罐号'] = rowdata['罐号']
      } else if (data.action === 'choose_station_oiltype') {
        carOrderOilData['油品名称'] = rowdata['油品名称']
      } else if (data.action === 'choose_station_ps') {
        carOrderOilData['罐号'] = rowdata['罐号']
      }
      this.carOrderTitle = carOrderTitle
      this.carOrderOilData = carOrderOilData
      this.showCarOrderType = 'oil'
      this.loadCarOrderListOil()
    },
    loadYaoHuoCheckList () {
      this.yaoHuoCheckList = []
      let parm = {
        action: 'get_yaohuo_checkdata',
        data: {}
      }
      depotValume(parm).then((data) => {
        this.yaoHuoCheckList = data
      })
    },
    addYaohuoToplan () {
      this.yaoHuoCheckList = []
      let parm = {
        action: 'add_yaohuo_toplan',
        data: {}
      }
      depotValume(parm).then((data) => {
        this.loadOrderList(['plan', 'normal'])
        this.$store.dispatch('showNoticeMsg', {
          type: 'success',
          title: '系统提示',
          message: '未上车要货订单已加入计划中'
        })
      })
    },
    initOnKeydown () {
      try {
        let needKeyCodes = [38, 40]
        document.onkeydown = (event) => {
          let keyCode = event.keyCode || null
          if (event.target.nodeName === 'BODY' && needKeyCodes.includes(keyCode)) {
            if (keyCode === 38) {
              this.nextCar('top')
            } else if (keyCode === 40) {
              this.nextCar('btm')
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    nextCar (key) {
      this.num += 1
      let value = ''
      if (key === 'top') {
        value = 'top_' + this.num
      } else if (key === 'btm') {
        value = 'btm_' + this.num
      }
      if (this.showOilDetail) {
        this.chooseOrderValue = value
      } else {
        this.chooseCarValue = value
      }
    },
    outputPsDatas () {
      this.$store.dispatch('outputPsDatas', {clear: true, oilType: this.outPutOilType})
      this.showOutput = false
    },
    loadData () {
      this.loadDepotList()
      this.loadYunJuList()
      this.getGasData()
    },
    getCarDetail () {
      let parm = {
        action: 'get_car_detail',
        data: {
          carId: this.chooseCar['车牌号']
        }
      }
      car(parm).then((data) => {
        this.carDetail = data
      })
    },
    chooseJsxQy (area) {
      this.selectArea = area
      this.$store.dispatch('filteHisJxcDatas', {area, oilType: this.oilType})
      this.showAreaJxc = true
    },
    dealInputCKSS (value, deal) {
      if (!deal) {
        this.inputPSL = 0
      }
      let num = Number(value) || 0
      if (!(num === 0 || num)) {
        this.inputCKSS = '0'
      }
      this.newOrder['平均销量'] = num
      this.newOrder['出库升数'] = num
      this.newOrder['期末库存'] = this.newOrder['期初库存'] - value + this.newOrder['入库升数']
      this.newOrder['空容'] = this.chooseG['物理容积'] - this.newOrder['期末库存']
      if (num !== 0) {
        let dhHour = ((this.newOrder['期末库存'] || 0) - (this.chooseG['停泵库存'] || 0)) / num * 24 + 8
        this.newOrder['断货时间'] = dateOperating.formatDate({date: new Date((new Date(this.todayStr + 'T00:00')).getTime() + (dhHour + 24) * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm'}).slice(5)
      } else {
        this.newOrder['断货时间'] = ''
      }
    },
    dealInputPSL (value) {
      let num = Number(value) || 0
      if (!(num === 0 || num)) {
        this.inputCKSS = '0'
      }
      this.newOrder['建议配送量'] = num
      if (num !== 0 && this.newOrder['平均销量']) {
        let dhHour = ((this.newOrder['期末库存'] || 0) - ((this.chooseG['有效容积'] || 0) - num)) / (this.newOrder['平均销量'] || 10000) * 24 + 8
        this.newOrder['不容纳时间'] = dateOperating.formatDate({date: new Date((new Date(this.todayStr + 'T00:00')).getTime() + dhHour * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm'}).slice(5)
      } else {
        this.newOrder['不容纳时间'] = ''
      }
    },
    addTsAction (action) {
      if (action === 'change') {
        this.chooseOrder = this.chooseOrderBX
        this.chooseOrderBX = null
        this.chooseOrderBXHis = null
      } else if (action === 'sc') {
        this.chooseOrderBXHis = this.chooseOrderBX
        this.chooseOrderBX = null
        this.saveCarOrder()
      } else {
        this.chooseOrderBX = null
        this.chooseOrderBXHis = null
      }
      this.showAddTs = false
    },
    saveTctz () {
      if (!this.tc) {
        return
      }
      let parm = {
        action: 'tc_tz',
        data: {
          data: this.chooseCarOrder,
          tc: this.tc
        }
      }
      depotValume(parm).then((data) => {
        this.showTctz = false
        this.loadCarOrderList()
      })
    },
    changeOrderStatus (sfid, status, isList) {
      let SFIDS = isList ? sfid : [sfid]
      this.orderList.forEach((item) => {
        if (SFIDS.includes(item['SFID'])) {
          item['STATUS'] = status
        }
      })
      let parm = {
        action: 'change_order_status',
        data: {
          sfid: SFIDS,
          status: status === 'done' ? 'normal' : status
        }
      }
      gas(parm)
    },
    saveSplitOrder () {
      let vm = this
      let amounts = []
      let total = 0
      for (let key in this.splitOrderData) {
        if (Number(key) === vm.splitNum || Number(key) < vm.splitNum) {
          amounts.push(vm.splitOrderData[key])
          total += Number(vm.splitOrderData[key])
        }
      }
      if (isNaN(total)) {
        return
      }
      let parm = {
        action: 'split_order',
        data: {
          order_id: this.chooseOrderChangeDepot['SFID'],
          amounts
        }
      }
      depotValume(parm).then((data) => {
        this.loadOrderList(['normal'])
        this.showSplitOrder = false
        this.splitNum = 2
      })
    },
    saveGasOrder () {
      if (!this.newOrder['油站代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择加油站'
        })
        return
      }
      if (!this.newOrder['出库升数']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请填写出库升数'
        })
        return
      }
      if (!this.newOrder['油库代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择配送油库'
        })
        return
      }
      if (!this.newOrder['建议配送量']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请填写建议配送量'
        })
        return
      }
      let parm = {
        action: 'add_gas_data',
        data: this.newOrder
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '配送单新增完成'
          })
          this.showAdd = false
          this.loadOrderList(['normal'])
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '配送单新增失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '配送单新增失败'
        })
      })
    },
    clearDcChooseOrderInDatas (sfids) {
      if (sfids.includes(this.chooseOrder1)) {
        this.chooseOrder1 = null
      }
      if (sfids.includes(this.chooseOrder2)) {
        this.chooseOrder2 = null
      }
      if (sfids.includes(this.chooseOrder3)) {
        this.chooseOrder3 = null
      }
    },
    clearOrders (clearDatas, type, status) {
      clearDatas = clearDatas || []
      let oldDatas = type === 'plan' ? this.chooseOrderCg : this.chooseOrders
      // 清chooseorder
      if (this.checkChooseOrderInDatas(oldDatas)) {
        this.chooseOrder = null
      }
      // 清多仓
      let SFIDs = []
      clearDatas.forEach((item) => {
        if (item && item['SFID']) {
          SFIDs.push(item['SFID'])
        }
      })
      this.clearDcChooseOrderInDatas(SFIDs)
      // 修改状态
      this.changeOrderStatus(SFIDs, status, true)
      // 清chooseOrderCg
      let newDatas = []
      oldDatas.forEach((item) => {
        if (!SFIDs.includes(item['SFID'])) {
          newDatas.push(item)
        }
      })
      if (type === 'plan') {
        this.chooseOrderCg = newDatas
      } else {
        this.chooseOrders = newDatas
      }
    },
    clickMenu (key) {
      if (key === 'add') {
        this.showAdd = true
        this.chooseGIndex = null
      } else if (key === 'yaohuo_check') {
        this.loadYaoHuoCheckList()
        this.showYaohuo = true
      } else if (key === 'clear3') {
        this.clearOrders(this.chooseOrderCg, 'plan', 'normal')
      } else if (key === 'clear') {
        this.clearOrders(this.chooseOrders, 'locking', 'normal')
      } else if (key === 'out_put') {
        this.showOutput = true
        this.$store.dispatch('getOrderCars')
        let depotCodes = []
        this.depotList.forEach((item) => {
          depotCodes.push(item['油库代码'])
        })
        this.$store.dispatch('getTjData', depotCodes)
      }
    },
    clickMenuS (key) {
      if (key === 'sys_pipei') {
        this.$store.dispatch('assignCarOrder', true)
      }
    },
    checkChooseOrderInDatas (datas) {
      let inDatas = false
      if (this.chooseOrder) {
        datas.forEach((item) => {
          if (item['SFID'] === this.chooseOrder['SFID']) {
            inDatas = true
          }
        })
      }
      return inDatas
    },
    chooseThisOrder (data) {
      if (data['STATUS'] === 'normal') {
        this.addToPlan(data)
      }
    },
    addToPlan (data) {
      let newOrder = mapCp(data)
      this.chooseOrderCg.push(newOrder)
      this.changeOrderStatus(data['SFID'], 'plan')
    },
    saveChangeOrderDepot () {
      let parm = {
        action: 'change_order_depot',
        data: {
          'depot_code': this.chooseOrderChangeDepot['油库代码'],
          'sfid': this.chooseOrderChangeDepot['SFID']
        }
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送油库成功'
          })
          this.loadOrderList(['normal'])
          this.showChooseDepot = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送油库失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送油库失败'
        })
      })
    },
    saveChangePsDepot () {
      let parm = {
        action: 'change_ps_depot',
        data: {
          'depot_code': this.psDepot,
          'order': this.chooseCarOrder,
          'allCarOrder': this.allCarOrder
        }
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改配送油库成功'
          })
          this.loadCarOrderList()
          this.showChooseDepotPs = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送油库失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送油库失败'
        })
      })
    },
    clickTdBtn (parm) {
      this.chooseCarOrder = parm.data
      if (parm.key === 'del') {
        this.delCarOrder()
      } else if (parm.key === 'save') {
        this.saveCarOrder()
      } else if (parm.key === 'oil_detail') {
        this.oilDetailMap = parm.data
        this.$store.dispatch('setOpdOilCode', this.oilDetailMap['油站代码'])
        this.showOilDetail = true
      } else if (parm.key === 'psk') {
        this.psDepot = this.chooseCarOrder['油库代码']
        this.showChooseDepotPs = true
      } else if (parm.key === 'tiao') {
        this.tc = ''
        this.tcList = []
        this.showTctz = true
        this.carOrderList.forEach((item) => {
          if (item['趟次'] !== this.chooseCarOrder['趟次'] && this.tcList.indexOf(item['趟次']) === -1) {
            this.tcList.push(item['趟次'])
          }
        })
      }
    },
    clickOrderTdBtnSD (parm) {
      let data = parm.data
      if (parm.key === 'back') {
        this.clearOrders([data], 'plan', 'normal')
      } else if (parm.key === 'clock') {
        this.chooseOrders.push(data)
        this.clearOrders([data], 'plan', 'plan')
      } else if (parm.key === 'area_jxc') {
        this.chooseJsxQy(data['区域'])
      }
    },
    clickOrderTdBtn (parm) {
      if (parm.key === 'back') {
        this.clearOrders([parm.data], 'locking', 'normal')
        return
      }
      if (parm.key === 'area_jxc') {
        this.chooseJsxQy(parm.data['区域'])
        return
      }
      if (parm.key === 'oil_detail') {
        this.oilDetailMap = parm.data
        this.$store.dispatch('setOpdOilCode', this.oilDetailMap['油站代码'])
        this.showOilDetail = true
        return
      }
      if (parm.key === 'detail') {
        this.showCarDetail = true
        this.carDetail = {
          psData: [],
          xzData: {}
        }
        this.chooseCar = parm.data
        this.getCarDetail()
        return
      }
      this.chooseOrderChangeDepot = mapCp(parm.data)
      if (parm.key === 'change_depot') {
        this.showChooseDepot = true
      } else if (parm.key === 'split_order') {
        this.showSplitOrder = true
      }
    },
    getOnlineTime (depotCode, gasCode) {
      let yunJu = this.yunJuMap[gasCode] ? this.yunJuMap[gasCode][depotCode] : 1000
      yunJu = yunJu || 1000
      return (yunJu / (yunJu > 100 ? 30 : 20)).toFixed(2)
    },
    getBRNTime (orderData, psl) {
      let qmkc = orderData['期末库存'] || 0
      let yxrj = orderData['有效容积'] || 0
      let pjxl = orderData['平均销量'] || 10000
      psl = psl || 0
      let dhHour = (qmkc - (yxrj - psl)) / pjxl * 24 + 8
      return dateOperating.formatDate({date: new Date((new Date(this.todayStr + 'T00:00')).getTime() + (dhHour + 24) * 60 * 60 * 1000), format: 'yy-mm-dd hh:mm'}).slice(5)
    },
    clickCarRow (data) {
      if (!data.dc) {
        this.chooseOrder = null
      }
      this.showCarOrderType = 'car'
      this.chooseCar = data
    },
    clickOrderRow (data) {
      this.showCarOrderType = 'car'
      if (this.chooseCar) {
        if (this.chooseCar.dc) {
          if (this.chooseOrder && this.chooseOrder['SFID'] !== data['SFID']) {
            this.chooseOrderBX = data
            this.showAddTs = true
          } else {
            this.chooseOrder = data
          }
        } else {
          if (this.chooseOrder1 === null && this.chooseCar['前仓']) {
            this.chooseOrder1 = data.SFID
          } else if (this.chooseOrder2 === null && this.chooseCar['中仓']) {
            this.chooseOrder2 = data.SFID
          } else if (this.chooseOrder2 === null && this.chooseCar['后仓']) {
            this.chooseOrder3 = data.SFID
          } else if (this.chooseCar['后仓']) {
            this.chooseOrder3 = data.SFID
          } else if (this.chooseCar['中仓']) {
            this.chooseOrder2 = data.SFID
          } else {
            this.chooseOrder1 = data.SFID
          }
        }
      }
    },
    loadCarList () {
      this.carLoading = true
      let parm = {
        action: 'get_work_cars',
        data: {
          oil_type: this.oilType,
          team: this.allCar ? '' : this.team
        }
      }
      car(parm).then((data) => {
        this.carList = data || []
        let inList = false
        this.carList.forEach((item) => {
          item['dc'] = !item['中仓'] && !item['后仓']
          item['oldPs'] = item['oldPs'].split('加油站').join('')
          item['承运商'] = item['承运商'].slice(0, 4)
          if (this.chooseCar && item['车牌号'] === this.chooseCar['车牌号']) {
            inList = true
          }
        })
        if (!inList) {
          this.chooseOrder = null
          this.chooseCar = null
        }
        this.carLoading = false
      })
    },
    loadDepotList () {
      let data = [{'油库代码': '33450015', '油库名称': '云南昆东油库'}, {'油库代码': '33450016', '油库名称': '云南长坡油库'}, {'油库代码': '36910016', '油库名称': '云南中石油安宁炼厂地付库'}, {'油库代码': '33450709', '油库名称': '云南石林油库'}]
      if (this.oilArea === 'dl') {
        data = [{'油库代码': '33450534', '油库名称': '云南凤仪油库'}, {'油库代码': '33451133', '油库名称': '云南振戎油库'}, {'油库代码': '36919004', '油库名称': '云南中石油清华洞油库'}, {'油库代码': '36910018', '油库名称': '云南中石油保山油库'}, {'油库代码': '33451833', '油库名称': '云南楚西油库'}]
      } else if (this.oilArea === 'hh') {
        data = [{'油库代码': '33450016', '油库名称': '云南长坡油库'}, {'油库代码': '33450348', '油库名称': '云南滇中油库'}, {'油库代码': '33450709', '油库名称': '云南石林油库'}, {'油库代码': '33453124', '油库名称': '云南文山广南油库'}, {'油库代码': '33453125', '油库名称': '云南红河蒙自油库'}, {'油库代码': '36910017', '油库名称': '云南中石油蒙自油库'}]
      } else if (this.oilArea === 'yx') {
        data = [{'油库代码': '33450016', '油库名称': '云南长坡油库'}, {'油库代码': '33450348', '油库名称': '云南滇中油库'}, {'油库代码': '33450709', '油库名称': '云南石林油库'}]
      } else if (this.oilArea === 'zt') {
        data = [{'油库代码': '33450211', '油库名称': '云南松林油库'}, {'油库代码': '33450622', '油库名称': '云南水富油库'}, {'油库代码': '33450709', '油库名称': '云南石林油库'}, {'油库代码': '33451453', '油库名称': '云南北闸油库'}]
      }
      this.depotList = data
    },
    loadOrderList (typeData) {
      this.orderLoading = true
      let parm = {
        action: 'get_no_car_order',
        data: {
          oil_type: this.oilType,
          order_status: this.orderStatus,
          team: this.team,
          type: typeData
        }
      }
      gas(parm).then((data) => {
        if (typeData.indexOf('normal') > -1) {
          let orderList = data.orderData || []
          orderList.forEach((item) => {
            this.delOrderData(item)
          })
          this.orderList = data.orderData
        }
        if (typeData.indexOf('plan') > -1) {
          let planData = data.planData || []
          let choosedDatasId = []
          this.chooseOrders.forEach((item) => {
            choosedDatasId.push(item['SFID'])
          })
          let newData = []
          planData.forEach((item) => {
            if (!choosedDatasId.includes(item['SFID'])) {
              newData.push(this.delOrderData(item))
            }
          })
          this.chooseOrderCg = newData
        }
        this.orderLoading = false
      })
    },
    loadCarOrderList () {
      this.carOrderLoading = true
      this.carOrderList = []
      let parm = {
        action: 'get_car_order',
        data: {
          car_id: this.chooseCar['车牌号']
        }
      }
      depotValume(parm).then((data) => {
        data.forEach((item) => {
          this.delCarOrderData(item)
        })
        this.carOrderList = data || []
        this.carOrderLoading = false
      })
    },
    loadCarOrderListOil () {
      this.carOrderLoading = true
      this.showOilCarOrderList = []
      let parm = {
        action: 'get_car_order',
        data: this.carOrderOilData
      }
      depotValume(parm).then((data) => {
        data.forEach((item) => {
          this.delCarOrderData(item)
        })
        this.showOilCarOrderList = data || []
        this.carOrderLoading = false
      })
    },
    loadYunJuList () {
      let parm = {
        action: 'get_yun_ju',
        data: 'none'
      }
      gas(parm).then((data) => {
        let yunJuMap = {}
        data.forEach((item) => {
          yunJuMap[item['到站代码']] = yunJuMap[item['到站代码']] ? yunJuMap[item['到站代码']] : {}
          yunJuMap[item['到站代码']][item['发站代码']] = item['运距']
        })
        this.yunJuMap = yunJuMap
      })
    },
    getGasData () {
      let parm = {
        action: 'get_gas_data',
        data: 'none'
      }
      gas(parm).then((data) => {
        this.gasDatas = data
      })
    },
    saveCarOrder () {
      // 保存配送单
      this.carOrderLoading = true
      let datas = [{
        '车牌号': this.chooseCar['车牌号'],
        '时间': this.chooseOrder['时间'],
        '油库代码': this.chooseOrder['油库代码'],
        '油站代码': this.chooseOrder['油站代码'],
        '代号': this.chooseOrder['代号'],
        '不容纳时间': this.newCarOrder['不容纳时间'],
        '油品名称': this.newCarOrder['油品名称'],
        '配送升数': this.newCarOrder['配送升数'],
        '在途时间': this.newCarOrder['在途时间'],
        'SFID': this.chooseOrder['SFID'],
        '隔仓号': 1,
        '数据来源': 1
      }]
      let parm = {
        action: 'add_car_order',
        data: datas
      }
      depotValume(parm).then((data) => {
        this.clearOrders([this.chooseOrder], 'plan', 'done')
        this.clearOrders([this.chooseOrder], 'locking', 'done')
        if (this.chooseOrderBXHis) {
          this.chooseOrder = this.chooseOrderBXHis
          this.chooseOrderBXHis = null
        }
        this.carOrderLoading = false
        this.loadCarList()
        this.loadOrderList(['normal'])
        this.loadCarOrderList()
      })
    },
    delOrderData (item) {
      item['建议配送量'] = parseInt(item['建议配送量'])
      item['油站名'] = item['加油站名称'].split('加油站')[0] + (item['加油站名称'].split('加油站')[1] || '')
      item['油品名'] = item['油品名称'].split('号')[0]
      item['订单紧急'] = item['订单紧急程度'] ? item['订单紧急程度'].slice(0, -2) : ''
      item['油库'] = item['油库名称'] ? item['油库名称'].split('油库')[0] : ''
      return item
    },
    delCarOrderData (item) {
      item['油站名'] = item['加油站名称'].split('加油站')[0] + (item['加油站名称'].split('加油站')[1] || '')
      item['油品名'] = item['油品名称'].split('号')[0]
      item['油库'] = item['油库名称'].split('油库')[0]
      return item
    },
    saveCarOrderDuo () {
      // 保存配送单
      if (!this.chooseAdjustOrders['qc'] && !this.chooseAdjustOrders['zc'] && !this.chooseAdjustOrders['hc']) {
        return
      }
      this.carOrderLoading = true
      let cdData = []
      let i = 1
      let datas = []
      for (let key in this.chooseAdjustOrders) {
        if (this.chooseAdjustOrders[key]) {
          datas.push(this.chooseAdjustOrders[key])
          let psss = key === 'qc' ? this.chooseCar['前仓'] : (key === 'zc' ? this.chooseCar['中仓'] : this.chooseCar['后仓'])
          cdData.push({
            '车牌号': this.chooseCar['车牌号'],
            '时间': this.chooseAdjustOrders[key]['时间'],
            '油库代码': this.chooseAdjustOrders[key]['油库代码'],
            '油站代码': this.chooseAdjustOrders[key]['油站代码'],
            '代号': this.chooseAdjustOrders[key]['代号'],
            '油品名称': this.chooseAdjustOrders[key]['油品名称'],
            '配送升数': psss,
            '不容纳时间': this.getBRNTime(this.chooseAdjustOrders[key], psss),
            '在途时间': this.getOnlineTime(this.chooseAdjustOrders[key]['油库代码'], this.chooseAdjustOrders[key]['油站代码']),
            'SFID': this.chooseAdjustOrders[key]['SFID'],
            '隔仓号': i,
            '数据来源': 1
          })
          i += 1
        }
      }
      let parm = {
        action: 'add_car_order',
        data: cdData
      }
      this.chooseOrder1 = null
      this.chooseOrder2 = null
      this.chooseOrder3 = null
      depotValume(parm).then((data) => {
        this.clearOrders(datas, 'plan', 'done')
        this.clearOrders(datas, 'locking', 'done')
        this.carOrderLoading = false
        this.loadCarList()
        this.loadOrderList(['normal'])
        this.loadCarOrderList()
      })
    },
    searchInputChange1 (value) {
      this.wfpKey = value.toUpperCase()
    },
    searchInputChange3 (value) {
      this.searchYaohuo = value.toUpperCase()
    },
    searchInputChange2 (value) {
      this.carKey = value.toUpperCase()
    },
    delCarOrder () {
      this.carOrderLoading = true
      let parm = {
        action: 'del_car_order',
        data: {
          'carId': this.chooseCarOrder['车牌号'],
          'date': this.chooseCarOrder['时间'],
          'index': this.chooseCarOrder['趟次']
        }
      }
      depotValume(parm).then((data) => {
        // 添加到 锁定
        data = data || []
        let SFIDs = []
        data.forEach((item) => {
          this.chooseOrders.push(this.delOrderData(item))
          if (!SFIDs.includes(item['SFID'])) {
            SFIDs.push(item['SFID'])
          }
        })
        // 修改为plan
        this.changeOrderStatus(SFIDs, 'plan', true)
        this.carOrderLoading = false
        this.loadCarList()
        this.loadOrderList(['normal'])
        if (this.showCarOrderType === 'car') {
          this.loadCarOrderList()
        } else {
          this.loadCarOrderListOil()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.select-order {
  display: flex;
  align-items: center;
  margin-right: 2rem;
  flex: 1;
}
.static-content {
  position: relative;
}
.static-content-div {
  position: absolute;
  height: 2.5rem;
  min-height: 2.5rem;
  top: 0;
  right: 7rem;
  left: 10rem;
  display: flex;
  align-items: center;
}
.qysx-btn-div {
  min-width: 5rem;
}
.qysx-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.3;
  font-size: 0.8rem;
  margin-left: 1rem;
  border-radius: 0.5rem;
}
.case-form-gas {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .one-input {
    width: 40%;
    margin-top: 1rem;
  }
}
.ajust-order {
  height: 100%;
  padding: 0;
}
.href-content {
  margin: 0 1rem;
  flex: 1;
  display: flex;
  min-height: 0;
}
.left-content {
  .content-shadow;
  .content-radius;
  flex: 1;
  margin-top: 1rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
}

.right-content-1 {
  .content-shadow;
  .content-radius;
  flex: 1;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}
.right-content-1-s {
  flex: 1;
}
.right-content-1-b {
  flex: 3;
}
.right-content-1-2 {
  .content-shadow;
  .content-radius;
  flex: 2;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}
.right-content-1-2-s {
  flex: 1;
}
.right-content-1-2-b {
  flex: 3;
}
.right-content-2 {
  flex: 2;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}
.adjust-btn {
  background-color: #081633;
  color: #00ccff;
  font-size: 0.8rem;
  line-height: 1.6;
  padding: 0 0.5rem;
  border-radius: 0.3rem;
}
.search-form {
  display: flex;
  flex-direction: column;
  max-width: 20%;
  min-width: 20%;
  .form-content {
    flex: 1;
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// adjust_order.vue?57a57445